import { t } from '@trimble/i18n';
import type { TreeNodeDefinition } from '@trimble/ui-components/solidjs';

import { isExtractedFeatureTreeNodeKind } from './fx-workspace-tree-nodes';
import type { FxWorkspaceTreeItem } from './fx-workspace-tree.types';
import { filterProjectDataNodes } from './project-data-filtering';

export type FxReferencesFilterMode = 'active' | 'workspace';

export const FX_REFERENCES_FILTER_OPTIONS: () => Array<{
  key: FxReferencesFilterMode;
  label: string;
}> = () => [
  {
    key: 'active',
    label: t('mobileMapping.fxWorkspace.references.filter.activeData'),
  },
  {
    key: 'workspace',
    label: t('mobileMapping.fxWorkspace.references.filter.workspaceData'),
  },
];

export function isReferencesTreeNodeKind(
  kind: FxWorkspaceTreeItem['kind'] | undefined
): boolean {
  return (
    kind === 'references' ||
    kind === 'referenceCategory' ||
    kind === 'referenceMission' ||
    kind === 'referenceRuns' ||
    kind === 'referenceFolder' ||
    kind === 'reference'
  );
}

export function applyFxReferencesFilter(
  nodes: TreeNodeDefinition<FxWorkspaceTreeItem>[],
  isMatch: (node: TreeNodeDefinition<FxWorkspaceTreeItem>) => boolean
): TreeNodeDefinition<FxWorkspaceTreeItem>[] {
  const extracted = nodes.filter((node) =>
    isExtractedFeatureTreeNodeKind(node.data?.kind)
  );
  const references = nodes.filter((node) =>
    isReferencesTreeNodeKind(node.data?.kind)
  );
  const filteredReferences = filterProjectDataNodes(
    references,
    'active',
    '',
    isMatch
  ).nodes.filter((node) => {
    if (node.data?.kind !== 'reference') {
      return true;
    }

    return isMatch(node);
  });

  return [...extracted, ...filteredReferences];
}
